// src/services/hubWebSocketService.js
// A simple WebSocket service for connecting/disconnecting to the hub and sending messages.

import { hubServiceUrl, connectionHub } from '../config/config';

class HubWebSocketService {
  constructor() {
    this.ws = null;
    this.onMessage = null;
    this.onOpen = null;
    this.onClose = null;
    this.onError = null;
  }

  connect({ clientId, token, onMessage, onOpen, onClose, onError }) {
    if (this.isConnected()) return;

    if (!token || !clientId) return;

    const hubId = connectionHub; // Hub ID from config
    const wsUrl = hubServiceUrl.replace(/^http/, 'ws'); // Convert http(s) to ws(s)
    const url = `${wsUrl}/ws?hub_id=${hubId}&token=${token}&clientId=${clientId}`;
    this.ws = new WebSocket(url);
    this.onMessage = onMessage;
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.onError = onError;

    this.ws.onopen = (event) => {
      if (this.onOpen) this.onOpen(event);
    };
    this.ws.onmessage = (event) => {
      if (this.onMessage) this.onMessage(event.data);
    };
    this.ws.onclose = (event) => {
      if (this.onClose) this.onClose(event);
      this.ws = null;
    };
    this.ws.onerror = (err) => {
      if (this.onError) this.onError(err);
    };
  }

  sendMessage(msg) {
    if (this.isConnected()) {
      this.ws.send(msg);
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }
}

const hubWebSocketService = new HubWebSocketService();
export default hubWebSocketService;
